import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "sftp",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import(/* webpackChunkName: "sftp" */ "./components")]).then(
        ([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
});
